import { createContext, useCallback, useRef, useState } from 'react';
import { ExecutePaymentResponseDto } from '@tiendanube/common';
import { StatusType } from 'commons/types';

type CheckoutContextType = {
  payOrderId: string;
  setOnPay: (onPay: () => void) => void;
  onPay: () => void;
  status: StatusType;
  setStatus: (status: StatusType) => void;
  creditCardPaymentData: ExecutePaymentResponseDto | null;
  setCreditCardPaymentData: (
    creditCardPaymentData: ExecutePaymentResponseDto | null,
  ) => void;
  creditCardFormError: boolean;
  setCreditCardFormError: (creditCardFormError: boolean) => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const CheckoutContext = createContext<CheckoutContextType>({
  payOrderId: '',
  setOnPay: noop,
  onPay: noop,
  status: 'idle',
  setStatus: noop,
  creditCardPaymentData: null,
  setCreditCardPaymentData: noop,
  creditCardFormError: false,
  setCreditCardFormError: noop,
});

function CheckoutProvider({
  payOrderId,
  children,
}: {
  payOrderId: string;
  children: React.ReactNode;
}) {
  const refOnPay = useRef<() => void>(noop);
  const [status, setStatus] = useState<StatusType>('idle');
  const [creditCardPaymentData, setCreditCardPaymentData] =
    useState<ExecutePaymentResponseDto | null>(null);

  const [creditCardFormError, setCreditCardFormError] = useState(false);

  const setOnPay = useCallback((onPay: () => void) => {
    refOnPay.current = onPay;
  }, []);

  const onPay = useCallback(() => {
    refOnPay.current();
  }, []);

  return (
    <CheckoutContext.Provider
      value={{
        payOrderId,
        setOnPay,
        onPay,
        status,
        setStatus,
        creditCardPaymentData,
        setCreditCardPaymentData,
        creditCardFormError,
        setCreditCardFormError,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
}

export default CheckoutProvider;
export { CheckoutContext };
